import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { NotificationMeta } from 'api/notifications/meta';

export const UnfinishedView: FC<{ meta: NotificationMeta }> = ({
  meta: { eventType },
}) => (
  <div>
    <FormattedMessage
      id="notifications.messages.unknown_event_type"
      values={{ eventType }}
    />
  </div>
);
